import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { Button } from './Button';
import { FirebaseContext } from './context';
import { Loader } from './Loader';
import { IQuest } from './models';
import { News } from './News';
import { QuestCard } from './QuestCard';

export const PageQuests = () => {
    const { db } = useContext(FirebaseContext);
    const [ quests, setQuests ] = useState<IQuest[]>([]);
    const [ loading, setLoading ] = useState(true);
    const [ shift, setShift ] = useState(12);
    useEffect(() => {
        if (db) {
            return onSnapshot(query(collection(db, '/v2-quests'), limit(shift), orderBy('date', 'desc')), (snapshot) => {
                setQuests(snapshot.docs.map((doc) => {
                    setLoading(false);
                    return {...doc.data(), id: doc.id} as IQuest;
                }));
            });
        }
    }, [db, shift]);
    return <div>
        <Loader loading={loading} />
        <div className='text-center py-10'>
            <p className="text-4xl mb-5">Квесты</p>
            <p className="text-lg">Выполняйте квесты и получайте награды</p>
        </div>
        <div className='padding-x flex flex-wrap gap-10 justify-center'>
            {quests.map((item) => <QuestCard key={item.id} id={item.id} image={item.image} title={item.title} description={item.description} date={item.date ? moment(item.date.toMillis()).fromNow() : undefined} steps={item.steps?.length} experience={item.experience}/>)}
        </div>
        <div className="py-10 flex justify-center">
            <Button label='Загрузить ещё' onClick={() => setShift(shift + 12)}/>
        </div>
    </div>
}